module.exports = __webpack_public_path__ + "img/right-icon-2.6bf44522.png";